/**
 * TODO: Remove the code when we upgrade to `@quickcommerceltd/zipp:1.2.9` and fetch it from there.
 */

export enum WarehouseType {
    DISTRIBUTION = 'distribution-center',
    STORE = 'store',
}
